var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "black",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 16.2929C9.90237 16.6834 9.90237 17.3166 10.2929 17.7071L16.6569 24.0711C17.0474 24.4616 17.6805 24.4616 18.0711 24.0711C18.4616 23.6805 18.4616 23.0474 18.0711 22.6569L12.4142 17L18.0711 11.3431C18.4616 10.9526 18.4616 10.3195 18.0711 9.92893C17.6805 9.53841 17.0474 9.53841 16.6569 9.92893L10.2929 16.2929ZM24 17V16H11V17V18H24V17Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowIcon);
export default __webpack_public_path__ + "static/media/circle-arrow-icon.b101efe3db005d8717c3ce36087a14a8.svg";
export { ForwardRef as ReactComponent };